import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

const initialState = {
  value: ""
};

export const versionSlice = createSlice({
  name: "version",
  initialState,
  reducers: {
    updateVersion: (state,action) => {
      state.value =action.payload;
    }
  },
});

export const { updateVersion } = versionSlice.actions;
export const getVersion = (state:RootState) => state.version.value;
export default versionSlice.reducer;